import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class MeetingLaunchService {
  constructor() {}

  launchMeeting(meeting: any, asGuest = true) {
    const meetingId = meeting._id;

    if (asGuest) {
      window.location.href = `/#/webex/${meetingId}/?GuestLogin=true`;
    } else {
      localStorage.removeItem('WebexAcessToken');
      const token = localStorage.getItem('token');

      const w = 600;
      const h = 600;
      const left = (screen.width - w) / 2;
      const top = (screen.height - h) / 2;

      setTimeout(() => {
        window.open(environment.webexUrl, 'popup',
          `width=${w}, height=${h}, top=${top}, left=${left}`);
      }, 1800);

      localStorage.setItem('meetingId', meetingId);
      localStorage.setItem('isModerator', 'true');
      localStorage.setItem('isMeetingInitiated', 'initiate');
    }
  }
}